module.exports = __webpack_public_path__ + "static/media/TUNE_3310.8011be38.jpg";